import { useQuery } from "react-query";
import SkillsReportsService from "./SkillsReportsService";
import { useContext } from "react";
import { AppAuthContext } from "../../../../../core/contexts/AppAuthProvider";

const useSkillsReports = () => {
  const { authenticatedUser } = useContext(AppAuthContext);
  const department = authenticatedUser?.department;

  const { data: rawData, isLoading: loadingTopSkills } = useQuery(
    ["topSkillsByDepartment", department],
    () => SkillsReportsService.getTopSkillsByDepartment(department),
    { enabled: !!department }
  );

  const { data: skillLevelsDistribution, isLoading: loadingSkillLevels } =
    useQuery(
      ["skillLevelsFiltered", department],
      () => SkillsReportsService.getSkillLevelsFilteredByDepartment(department),
      { enabled: !!department }
    );

  const {
    data: skillDistributionByCategory,
    isLoading: loadingSkillDistribution,
  } = useQuery(
    ["skillDistributionByCategory", department],
    () => SkillsReportsService.getSkillDistributionByCategory(department),
    { enabled: !!department }
  );

  const { data: skillCategoriesData, isLoading: loadingSkillCategories } =
    useQuery("skillCategories", SkillsReportsService.getSkillCategories);

  const {
    data: skillAcquisitionProgressData,
    isLoading: loadingSkillAcquisition,
  } = useQuery(
    ["skillAcquisitionProgress", department],
    () => SkillsReportsService.getSkillAcquisitionProgress(department),
    { enabled: !!department }
  );

  const fetchSkillLevelsByCategoriesAndTeams = async (categories) => {
    const res = await SkillsReportsService.getSkillLevelsFilteredByDepartment(
      department,
      categories
    );
    return res.data;
  };

  const { data: manualRequestsStats, isLoading: loadingManualStats } = useQuery(
    ["manualRequestsStats", department],
    () => SkillsReportsService.getManualRequestsStats(department),
    { enabled: !!department }
  );

  const { data: certifiedRequestsStats, isLoading: loadingCertifiedStats } =
    useQuery(
      ["certifiedRequestsStats", department],
      () => SkillsReportsService.getCertifiedRequestsStats(department),
      { enabled: !!department }
    );

  return {
    rawTopSkillsData: rawData?.data || [],
    loadingTopSkills,
    skillLevelsDistribution: skillLevelsDistribution?.data || [],
    loadingSkillLevels,
    skillDistributionByCategory: skillDistributionByCategory?.data || [],
    loadingSkillDistribution,
    skillCategories: skillCategoriesData?.data || [],
    loadingSkillCategories,
    skillAcquisitionProgress: skillAcquisitionProgressData?.data || [],
    loadingSkillAcquisition,
    fetchSkillLevelsByCategoriesAndTeams,
    manualRequestsStats: manualRequestsStats?.data || {},
    certifiedRequestsStats: certifiedRequestsStats?.data || {},
    loadingManualStats,
    loadingCertifiedStats,
  };
};

export default useSkillsReports;
